import { Exercice } from "./exercice";

export interface SessionItemExerciceData {
  id?: number;
  exerciceId?: number;
  sessionItemWrapperId?: number;
  nbRepeat?: number;
  duration?: number;
  nbSerie?: number;
  payload?: number;
  restTime?: number;
  comment?: string;
  ord?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  exercise?: Exercice;

}

export class SessionItemExercice {
  public static readonly TYPE_EXERCICE: string = 'EXERCICE';

  public static getNonTranslatableFields(): string[] { return ['id', 'exerciceId', 'sessionItemWrapperId', 'nbRepeat', 'duration', 'nbSerie', 'payload', 'restTime', 'comment', 'ord', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'exerciceId', 'sessionItemWrapperId', 'nbRepeat', 'duration', 'nbSerie', 'payload', 'restTime', 'comment', 'ord', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  exerciceId?: number;
  sessionItemWrapperId?: number;
  nbRepeat?: number;
  duration?: number;
  nbSerie?: number;
  payload?: number;
  restTime?: number;
  comment?: string;
  ord?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  exercise?: Exercice;

  public static fromAPI(data: SessionItemExerciceData): SessionItemExercice {
    if (data.exercise) {
      data.exercise = Exercice.fromAPI(data.exercise);
    }
    return new SessionItemExercice(data);
  }

  public static fromAPIList(data: SessionItemExerciceData[]): SessionItemExercice[] {
    return data.map((item) => SessionItemExercice.fromAPI(item));
  }

  constructor({id, exerciceId, sessionItemWrapperId, nbRepeat, duration, nbSerie, payload, restTime, comment, ord, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
              exercise} : SessionItemExerciceData) {
    this.id = id;
    this.exerciceId = exerciceId;
    this.sessionItemWrapperId = sessionItemWrapperId;
    this.nbRepeat = nbRepeat;
    this.duration = duration;
    this.nbSerie = nbSerie;
    this.payload = payload;
    this.restTime = restTime;
    this.comment = comment;
    this.ord = ord;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.exercise = exercise;
  }

  public toJson(): SessionItemExerciceData {
    return {
      id: this.id,
      exerciceId: this.exerciceId,
      sessionItemWrapperId: this.sessionItemWrapperId,
      nbRepeat: this.nbRepeat,
      duration: this.duration,
      nbSerie: this.nbSerie,
      payload: this.payload,
      restTime: this.restTime,
      comment: this.comment,
      ord: this.ord,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
